<div class="nav-menu" [class.nav-collapsed]="collapsed" *ngIf="countingModule == 1">
  <mat-accordion [multi]="false">
    <ng-container *ngFor="let section of navSections">

      <div class="nav-section-label" *ngIf="section.label">{{ section.label }}</div>

      <ng-container *ngFor="let m of section.items">

        <!-- Single Menu Item (no children) -->
        <a *ngIf="m.children == undefined; else multiBlock"
           class="nav-item"
           routerLink="{{m.link}}"
           routerLinkActive="active"
           [matTooltip]="'nav.header.' + m.key | translate"
           [matTooltipDisabled]="!collapsed"
           matTooltipPosition="right"
           (click)="onNavigate()">
          <div class="nav-item__icon">
            <img src="./../../assets/menu/{{m.key}}.svg" alt="" />
          </div>
          <span class="nav-item__text">{{ "nav.header." + m.key | translate }}</span>
          <span class="nav-badge" *ngIf="badgeFor(m.key) != null">{{ badgeFor(m.key) }}</span>
          <mat-icon class="nav-item__arrow">chevron_right</mat-icon>
        </a>

        <!-- Menu Item with Children -->
        <ng-template #multiBlock>

          <!-- COLLAPSED: icon only; clicking opens a flyout to the RIGHT with the children -->
          <ng-container *ngIf="collapsed; else expandedParent">
            <a class="nav-item nav-rail-parent"
               cdkOverlayOrigin #railTrigger="cdkOverlayOrigin"
               [class.active]="openFlyoutKey === m.key"
               (click)="toggleFlyout(m.key)">
              <div class="nav-item__icon">
                <img src="./../../assets/menu/{{m.key}}.svg" alt="" />
              </div>
            </a>
            <ng-template cdkConnectedOverlay
              [cdkConnectedOverlayOrigin]="railTrigger"
              [cdkConnectedOverlayOpen]="openFlyoutKey === m.key"
              [cdkConnectedOverlayPositions]="flyoutPositions"
              [cdkConnectedOverlayHasBackdrop]="true"
              cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
              (backdropClick)="closeFlyout()"
              (detach)="closeFlyout()">
              <div class="rail-flyout">
                <div class="rail-flyout__title">{{ "nav.header." + m.key | translate }}</div>
                <ng-container *ngFor="let item of m.children">
                  <a class="rail-flyout__item" *ngIf="item.external == true; else flyInternal"
                     target="{{item.target}}" href="{{item.link}}" (click)="closeFlyout()">
                    {{ "nav.sub." + item.key | translate }}
                  </a>
                  <ng-template #flyInternal>
                    <a class="rail-flyout__item" routerLink="{{item.link}}" routerLinkActive="active"
                       [routerLinkActiveOptions]="{exact: true}" (click)="onNavigate(); closeFlyout()">
                      {{ "nav.sub." + item.key | translate }}
                    </a>
                  </ng-template>
                </ng-container>
              </div>
            </ng-template>
          </ng-container>

          <!-- EXPANDED: full accordion -->
          <ng-template #expandedParent>
          <mat-expansion-panel #panel
            [expanded]="openedPanelKey === m.key"
            class="nav-accordion"
            (opened)="onPanelOpened(m.key)"
            (closed)="onPanelClosed(m.key)">
            <mat-expansion-panel-header class="nav-accordion__header"
              [matTooltip]="'nav.header.' + m.key | translate"
              [matTooltipDisabled]="!collapsed"
              matTooltipPosition="right"
              (click)="onCollapsedParentClick()">
              <mat-panel-title class="nav-accordion__title">
                <div class="nav-item__icon">
                  <img src="./../../assets/menu/{{m.key}}.svg" alt="" />
                </div>
                <span class="nav-item__text">{{ "nav.header." + m.key | translate }}</span>
                <span class="nav-badge" [class.nav-badge--amber]="m.key === 'counts'" *ngIf="badgeFor(m.key) != null">{{ badgeFor(m.key) }}</span>
                <mat-icon class="nav-item__arrow">{{ panel.expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
              </mat-panel-title>
            </mat-expansion-panel-header>

            <!-- Sub Menu Items -->
            <div class="nav-submenu">
              <ng-container *ngFor="let item of m.children">
                <a *ngIf="item.external == true; else internalLink"
                   class="nav-submenu__item"
                   target="{{item.target}}"
                   href="{{item.link}}">
                  <span class="nav-submenu__dot"></span>
                  <span class="nav-submenu__text">{{ "nav.sub." + item.key | translate }}</span>
                </a>
                <ng-template #internalLink>
                  <a class="nav-submenu__item"
                     routerLink="{{item.link}}"
                     routerLinkActive="active"
                     [routerLinkActiveOptions]="{exact: true}"
                     (click)="onNavigate()">
                    <span class="nav-submenu__dot"></span>
                    <span class="nav-submenu__text">{{ "nav.sub." + item.key | translate }}</span>
                  </a>
                </ng-template>
              </ng-container>
            </div>
          </mat-expansion-panel>
          </ng-template>
        </ng-template>

      </ng-container>
    </ng-container>
  </mat-accordion>
</div>
